<div class="container-fluid">
  <div>
    <div class="margin-top-8">
      <div class="header">
        {{!editing ? ( 'bikeshop.checklist.add_checklist' | translate ) : ( 'bikeshop.checklist.edit_checklist' |
        translate)}}
      </div>
      <div class="checklist_description">
        {{ 'bikeshop.checklist.checklist_description' | translate }}
      </div>
    </div>
    <div class="margin-top-8 info-container content">
      <p-progressSpinner *ngIf="loading" [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
        animationDuration=".5s"></p-progressSpinner>


      <div class="row margin-top-16">
        <div class="col-md-4 label"
          [ngClass]="{'red': checklistItem.description === null || checklistItem.description === undefined || checklistItem.description.length === 0}">
          *{{ 'bikeshop.checklist.checklist_name' | translate }}
        </div>
        <div class="col-md-8 value">
          <input id="float-input" type="text" pInputText [(ngModel)]="checklistItem.description" />
        </div>
      </div>

      <div class="row margin-top-16">
        <div class="col-md-4 label">
          *{{ 'bikeshop.checklist.control_type' | translate }}
        </div>
        <div class="col-md-2 value">
          <p-dropdown [options]="controlTypeOptions" [(ngModel)]="checklistItem.controlType"></p-dropdown>
        </div>
        <div class="col-md-6 value">
          <small>{{ 'bikeshop.checklist.control_type_description' | translate }}</small>
        </div>
      </div>

      <div class="row margin-top-16">
        <div class="col-md-4 label">
          {{ 'bikeshop.checklist.is_pre_service_check' | translate }}
        </div>
        <div class="col-md-2 value">
          <p-inputSwitch [(ngModel)]="checklistItem.isPreServiceCheck"
            [disabled]="checklistItem.mandatoryForAllServices"></p-inputSwitch>
        </div>
        <div class="col-md-6 value">
          <small>{{ 'bikeshop.checklist.is_pre_service_check_description' | translate }}</small>
        </div>
      </div>

      <div class="row margin-top-16">
        <div class="col-md-4 label">
          {{ 'bikeshop.checklist.all_services_checklist' | translate }}
        </div>
        <div class="col-md-2 value">
          <p-inputSwitch [(ngModel)]="checklistItem.mandatoryForAllServices"
            [disabled]="checklistItem.isPreServiceCheck"></p-inputSwitch>
        </div>
        <div class="col-md-6 value">
          <small>{{ 'bikeshop.checklist.all_services_checklist_description' | translate }}</small>
        </div>
      </div>

      <div class="row margin-top-16">
        <div class="col-md-4 label">
          {{ 'bikeshop.checklist.front_rear_check' | translate }}
        </div>
        <div class="col-md-2 value">
          <p-inputSwitch [(ngModel)]="checklistItem.frontRearCheck"></p-inputSwitch>
        </div>
      </div>

      <div class="row margin-top-16">
        <div class="col-md-4 label" [ngStyle]="{ 'color': checklistItem.labelColour }">
          {{ 'bikeshop.checklist.label_colour' | translate }}
        </div>
        <div class="col-md-1 value">
          <div class="colour-item" [ngStyle]="{'background': checklistItem.labelColour}"></div>
        </div>
        <div class="col-md-1 value"></div>
        <div class="col-md-6 value">
          <div class="flex">
            <div class="colour-item gradient" [(colorPicker)]="checklistItem.labelColour" [cpPresetColors]="colourList"></div>
            <div *ngFor="let colour of colourList">
              <div class="colour-item" (click)="checklistItem.labelColour = colour;" [ngStyle]="{'background': colour}" [ngClass]="{'selected': checklistItem.labelColour === colour}"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 label"></div>
        <div class="col-md-6 value">
          <small>{{ 'bikeshop.checklist.label_colour_description' | translate }}</small>
        </div>
      </div>

      <div class="row margin-top-16">
        <div class="col-md-4"><button *ngIf="checklistItem.id" pButton (click)="delete()"
            class="p-button-raised alternate full-width" label="{{'bikeshop.general.delete' | translate}}"
            [disabled]="saving || loading"></button></div>
        <div class="col-md-4"></div>
        <div class="col-md-4"><button pButton (click)="save()" class="p-button-raised full-width"
            label="{{'bikeshop.general.save' | translate}}" [disabled]="saving || loading || !valid()"></button></div>
      </div>


    </div>
  </div>
  <p-confirmDialog key="add_edit_checklist"></p-confirmDialog>
